// extracted by mini-css-extract-plugin
export var faq = "faq-module--faq--1GZl3";
export var faq__box = "faq-module--faq__box--3f7mG";
export var faq__btn = "faq-module--faq__btn--yEIQM";
export var faq__details_content = "faq-module--faq__details_content--3kQ5W";
export var fadeIn = "faq-module--fadeIn--1bPMj";
export var faq__box_set = "faq-module--faq__box_set--32QD3";